import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { Spinner } from '@ui/components/loaders'
import { PageStatus } from '@ui/interfaces'
import { LoginContainer } from '@ui/pages/authentication/components'
import { useAuth } from '@ui/providers/AuthProvider'

export const Logout = () => {
  const auth = useAuth()
  const navigate = useNavigate()

  const [pageStatus, setPageStatus] = useState(PageStatus.INITIAL)
  const [pageError, setPageError] = useState<string>()

  useEffect(() => {
    let isMounted = true

    auth.signout((err) => {
      if (!isMounted) return
      if (err) {
        setPageStatus(PageStatus.FAIL)
        setPageError(err.message)
      } else {
        setPageStatus(PageStatus.SUCCESS)
        setTimeout(() => {
          if (isMounted) {
            navigate('/login')
          }
        }, 2000)
      }
    })

    return () => {
      isMounted = false
    }
  }, [auth, navigate])

  return (
    <LoginContainer>
      {pageStatus === PageStatus.INITIAL && (
        <div className="pt-6">
          Logging out
          <Spinner />
        </div>
      )}
      {pageStatus === PageStatus.SUCCESS && (
        <h1 className="pt-5 text-lg leading-tight tracking-tight text-green-600">
          <CheckCircleIcon className="mx-auto h-10 w-10" />
        </h1>
      )}
      {pageStatus === PageStatus.FAIL && (
        <h1 className="pt-5 text-lg leading-tight tracking-tight text-green-600">{pageError}</h1>
      )}
    </LoginContainer>
  )
}
